import React from 'react'
import { Heading } from '@myxplor/ui'

const Declaration = () => (
  <div className="formSection">
    <Heading small compact>Declaration</Heading>
    I understand by clicking the button below:
    <ol className="numbers">
      <li>I confirm the above correctly reflects my child’s expected regular schedule.</li>
      <li>I agree to the referenced fee schedule. </li>
      <li>I understand care may be provided on a casual or flexible basis where available at my service(s) at my request. </li>
      <li>I understand that the fee schedule may vary from time to time as notified by my child care provider and reflected in an updated fee schedule.</li>
    </ol>
  </div>
)

export default Declaration


// WEBPACK FOOTER //
// ./src/parent-agreement/views/declaration.jsx